module.exports = __webpack_public_path__ + "media/images/swines/Swine giving birth to a piglet.jpg";